/*
 * Copyright (c) 2023 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import { Text, TextProps } from '@mantine/core'
import { useSettingsContext } from '../SettingsProvider'

export type AmountProps = TextProps & {
  colored?: boolean
  value: number
  withCurrency?: boolean
  withSign?: boolean
}

function Amount (props: AmountProps) {
  const {
    colored,
    value,
    withCurrency,
    withSign,
    ...others
  } = props

  const intl = useIntl()
  const { settings } = useSettingsContext()

  const color = colored ? (value > 0 ? 'green' : 'red') : undefined

  return (
    <Text
      c={color}
      {...others}
    >
      {withSign && value > 0 ? '+' : null}
      {intl.formatNumber(value, {
        currency: settings?.CURRENCY,
        style: withCurrency ? 'currency' : undefined,
        compactDisplay: 'short'
        // currencySign: 'standard'
      })}
    </Text>
  )
}

export default Amount
